import { Link, useLocation } from 'react-router-dom';
import styles from './InvalidLinkPage.module.scss';
import { Button, Icon, Text } from 'components';

export const InvalidLinkPage = () => {
  const { state } = useLocation();
  return (
    <div className={styles.container}>
      <div className={styles.textContainer}>
        <Text type="h3" className={styles.title}>
          Oops, this link is not valid
        </Text>
        <Text type="body-big" className={styles.descriptionText}>
          Maybe the link was expired, revoked or is not correct. Please contact your account administrator for more
          details
        </Text>
        {state && (
          <Link to={state?.backPagePath} replace={true}>
            <Button type="secondary" onClick={() => undefined}>
              Get back
            </Button>
          </Link>
        )}
      </div>
      <div className={styles.logoContainer}>
        <Icon className={styles.logo} name="Logo" />
      </div>
    </div>
  );
};
